import { render, staticRenderFns } from "./MultipleViewer.vue?vue&type=template&id=3c39131c&scoped=true&"
import script from "./MultipleViewer.vue?vue&type=script&lang=js&"
export * from "./MultipleViewer.vue?vue&type=script&lang=js&"
import style0 from "./MultipleViewer.vue?vue&type=style&index=0&id=3c39131c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c39131c",
  null
  
)

export default component.exports